export function buildNoteExcerpt(
  rawNote: string | null,
  searchTerm: string,
  contextChars = 100
): string | null {
  if (!rawNote || !searchTerm.trim()) return null;
  const lower = rawNote.toLowerCase();
  const rawTokens = searchTerm.trim().split(/\s+/);
  const tokens = rawTokens.filter(t => t.length >= 2);
  const phraseMode = tokens.length <= 1 && tokens.length < rawTokens.length;
  if (tokens.length === 0 && !phraseMode) return null;
  const matchIndex = phraseMode
    ? (() => { const i = lower.indexOf(searchTerm.trim().toLowerCase()); return i !== -1 ? i : lower.length; })()
    : tokens.reduce((earliest, token) => {
        const idx = lower.indexOf(token.toLowerCase());
        return idx !== -1 && idx < earliest ? idx : earliest;
      }, lower.length);
  if (matchIndex === lower.length) return null;
  const start = Math.max(0, matchIndex - contextChars);
  const end = Math.min(rawNote.length, matchIndex + contextChars);
  const prefix = start > 0 ? "…" : "";
  const suffix = end < rawNote.length ? "…" : "";
  return prefix + rawNote.slice(start, end) + suffix;
}
